import { Link } from "react-router-dom";

export function Logo({ className = "", withText = true, onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 ${className}`}
      aria-label="Envago Labs home"
    >
      <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-primary text-primary-foreground overflow-hidden transition-transform duration-300 group-hover:scale-105">
        <svg viewBox="0 0 32 32" className="h-5 w-5" fill="none" aria-hidden="true">
          <path
            d="M6 16 L16 6 L26 16 L16 26 Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <circle cx="16" cy="16" r="3" fill="currentColor" />
        </svg>
        <span className="absolute inset-x-0 bottom-0 h-[3px] bg-gold" />
      </span>
      {withText && (
        <span className="font-display text-lg font-semibold tracking-tight leading-none">
          Envago<span className="text-primary"> Labs</span>
        </span>
      )}
    </Link>
  );
}
